import { createContext, useContext } from "react";
import { DialogInfoContextType } from "./types";

export const DialogInfoContext = createContext<DialogInfoContextType>({});

export const useDialogInfoContext = (): DialogInfoContextType => {
  return useContext(DialogInfoContext);
};
